import type { AnyFn } from "@onesolution/monday/utils";
import {
	createMiddleware,
	registerGlobalMiddleware,
} from "@tanstack/react-start";

const isProd = import.meta.env.PROD;

export const hideErrorOnProd = createMiddleware({
	type: "function",
}).server(async ({ next }: { next: AnyFn }) => {
	try {
		return await next();
	} catch (err) {
		if (isProd) throw "Server error.";

		throw err;
	}
});

registerGlobalMiddleware({ middleware: [hideErrorOnProd] });
